import { FC } from 'react';
import { useBaseContext } from '#base/hooks/use-base-context';
import { LoadMore } from '#advertList/components/catalog-by-date/LoadMore';
import { useAdvertListContext } from '#advertList/hooks/use-advert-list-context';
import { AdvertCardList, CatalogMode } from '#advert/components/card-list';

const CatalogByDate: FC = () => {
  const { catalogMode } = useBaseContext();
  const { advertDataListByDate } = useAdvertListContext();

  if (catalogMode !== CatalogMode.default) {
    return null;
  }

  const adverts = advertDataListByDate.chunkDataList.flatMap((chunk) => chunk.adverts);

  return (
    <>
      <AdvertCardList
        adverts={adverts}
        total={advertDataListByDate.pagination.totalCount}
      />
      <LoadMore />
    </>
  );
};

export { CatalogByDate };
